import { Form, Modal } from "react-bootstrap";
import React, { useState, useContext } from "react";
import { AuthContext } from "../../AuthProvider";
import Parse from "parse";

const HeatingAutomationStatus = () => {

    const { esp, setUserEsp } = useContext(AuthContext);

    const [showHelp, setShowHelp] = useState(false);

    const handleCloseHelp = () => setShowHelp(false);

    const handleShowHelp = () => setShowHelp(true);

    // Skicka kommando för att slå på/av automation
    const toggleAutomation = () => {
        Parse.Cloud.run("updateHeatingAutomation", {
            espId: esp.id, automationStatus: !esp.heating?.automationStatus
        }
        )
            .then((result) => setUserEsp(result));
    };

    return (
        <div>
            <Form className="automation-form">
                <Form.Group controlId="automationStatusHeating">
                    <div className="d-flex align-items-center">
                        <Form.Check
                            type="switch"
                            alt="Smart styrning aktiverad"
                            id="automation-status-switch"
                            checked={esp?.heating?.automationStatus}
                            onChange={toggleAutomation}
                        />
                        <span><strong>Smart styrning värme</strong></span>
                        <i className="bi bi-info-circle ms-2" onClick={handleShowHelp} style={{ cursor: 'pointer', color: '#007bff' }} />
                    </div>
                </Form.Group>
            </Form>

            <Modal show={showHelp} onHide={handleCloseHelp} centered>
                <Modal.Header closeButton>
                    <Modal.Title>Smart uppvärmning</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    Genom att slå av denna inställning inaktiveras den automatiska styrningen och värmepumpens egen styrning används istället.
                </Modal.Body>
            </Modal>
        </div >
    )
}

export default HeatingAutomationStatus;


